//
//
//
//
//
//
//
//

export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      "default": ''
    },
    title: {
      type: String,
      "default": ''
    }
  },
  render: function render(h, context) {
    var _context$props = context.props,
      title = _context$props.title,
      icon = _context$props.icon;
    var vnodes = [];
    if (icon) {
      vnodes.push(h("i", {
        "class": icon,
        "style": 'color: #979797'
      }));
    }
    if (title) {
      vnodes.push(h("span", {
        "slot": 'title'
      }, [title]));
    }
    return vnodes;
  }
};